import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { icons, IconSanitizerService, TooltipDirective } from 'ngx-lib';
import { UserInfoComponent } from '../user-info/user-info.component';

export interface ICardDetails {
    id?: number;
    name?: string;
    salespersons?: any[];
    latitude?: number;
    longitude?: number;
    mainInfo?: IDetailsInfo[];
    tooltip?: IDetailsInfo[];
    routerLinkConfig?: {
        base?: string;
        extra?: string[];
    };
}

export interface IDetailsInfo {
    label: string;
    value: string;
    link?: string;
}

@Component({
    selector: 'app-map-card',
    templateUrl: './map-card.component.html',
    styleUrls: ['./map-card.component.scss'],
    imports: [CommonModule, TooltipDirective, RouterLink, UserInfoComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        'animate.enter': 'card-enter',
        'animate.leave': 'card-leave'
    }
})
export class MapCardComponent implements OnInit {
    @Input()
    cardData?: ICardDetails;

    @Output()
    closeClicked: EventEmitter<void>;

    closeIcon?: SafeHtml;
    infoIcon?: SafeHtml;

    tooltipInfo?: SafeHtml;
    link?: string;

    readonly icons = icons;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.closeIcon = this.iconSanitizer.getIcon('close');
        this.infoIcon = this.iconSanitizer.getIcon('info');
        this.closeClicked = new EventEmitter<void>();
    }

    ngOnInit(): void {
        if (this.cardData?.tooltip?.length) {
            this.tooltipInfo = this.getTooltipInfo(this.cardData.tooltip);
        }
        if (this.cardData?.id && this.cardData?.routerLinkConfig?.base && this.cardData?.routerLinkConfig?.extra) {
            this.link =
                this.cardData?.routerLinkConfig?.base +
                '/' +
                this.cardData?.id +
                '/' +
                this.cardData?.routerLinkConfig?.extra;
        }
    }

    onCloseClicked(): void {
        this.closeClicked.emit();
    }

    preventDefaultNavigation(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
    }

    private getTooltipInfo(tips: IDetailsInfo[]): SafeHtml {
        const tooltipHtml = `
            <ul class="tooltip-container">
                ${tips
                    .map(
                        (tip) => `
                    <li class="tooltip-item">
                        <span class="tooltip-label">${tip.label}:</span>
                        <span class="tooltip-value">${tip.value || '-'}</span>
                    </li>
                `
                    )
                    .join('')}
            </ul>
        `;
        return tooltipHtml;
    }
}
